<template>
  <div id="stickybody" class="" style="padding-bottom: 10px;">
    <div class="sideber-top">
      <div class="row">
        <div class="aside_header_content">
          <h1>{{ info }}</h1>
          <hr />
        </div>
      </div>
    </div>
    <div class="aside_body_content">
      <div class="row">
        <div class="three columns">
          <aside id="desktopshow" class="aside">
            <div id="sidebar-fluid">
              <ul class="side-nemu">
                <li>
                  <span class="icon_sidebar"
                    ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
                  ><a class="aside_ul">Community Services</a>

                  <ul>
                    <li>
                      <span class="active_icon"></span
                      ><a class="active_sidebar">Hospital</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="side-nemu">
                <li>
                  <span class="icon_sidebar"
                    ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
                  ><a class="aside_ul">Emergency Services</a>

                  <ul>
                    <li>
                      <a>Hospital Number</a>
                    </li>
                    <li>
                      <a>Police Station</a>
                    </li>
                    <li>
                      <a>Fair Service</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <span id="placeholder">placeholder</span>
          </aside>
          <aside id="phoneshow" class="aside">
            <div id="sidebar-fluid" @click="toggledropdown">
              <h1>{{ info }}</h1>
              <ul class="side-nemu" v-if="openDown">
                <li @click="subdropdown()">
                  <span class="icon_sidebar"
                    ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
                  ><a class="aside_ul">Community Services</a>

                  <ul>
                    <li>
                      <span class="active_icon"></span
                      ><a class="active_sidebar">Hospital</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="side-nemu" v-if="openDown">
                <li>
                  <span class="icon_sidebar"
                    ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
                  ><a class="aside_ul">Emergency Services</a>

                  <ul>
                    <li>
                      <a>Hospital Number</a>
                    </li>
                    <li>
                      <a>Police Station</a>
                    </li>
                    <li>
                      <a>Fair Service</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                    <li>
                      <a>School</a>
                    </li>
                  </ul>
                </li>
              </ul>
               <span class="icon-drop1"><i class="fas fa-caret-down"></i></span>
            
            </div>
            <span id="placeholder">placeholder</span>
          </aside>
        </div>
        <div class="nine columns">
          <div class="columns columns_content">
            <h2>Hospital</h2>
            <p>
              Community engagement, which includes community service,
              service-learning and field-experience programs and activities is
              the collaboration between institutions of higher education and
              their larger communities (local, regional/state, national and
              global) for the mutually beneficial exchange of knowledge and
              resources in a context of partnership and reciprocity. The purpose
              of community engagement is the partnership of college and
              university knowledge and resources with those of the public and
              private sectors to enrich scholarship, research and creative
              activity; enhance curriculum, teaching and learning; prepare
              educated, engaged citizens; strengthen democratic values and civic
              responsibility; address critical societal issues; and contribute
              to the public good. (Carnegie Foundation for the Advancement of
              Teaching)
            </p>
            <p>
              Stewards of Place Stewards of Place describes a publicly engaged
              institution that is fully committed to direct, two-way interaction
              with communities and other external constituencies through the
              development, exchange, and application of knowledge, information
              and expertise for mutual benefit. (American Association of State
              Colleges and Universities, www.aascu.org)
            </p>
            <p>
              Service-Learning Service-Learning is a teaching and learning
              strategy that integrates meaningful community service with
              instruction and reflection to enrich the learning experience,
              teach civic responsibility and strengthen communities. (Carnegie
              Foundation for the Advancement of Teaching)
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="./js/sticky-sidebar.js"></script>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "stickybody",

  data() {
    return {
      info: "Services",
      openPositive: false,
      openNagative: true,
      openpost: true,
      openUp: true,
      openDown: false,
    };
  },
  components: {},
  mounted() {},
  methods: {
    toggledropdown() {
      this.openUp = !this.openUp;
      this.openDown = !this.openDown;
    },
    togglepost() {
      this.openpost = !this.openpost;
    },
  },
};
</script>


<style scoped>
::-webkit-scrollbar {
  width: 10px;
}
.shadow-body {
  background: #fff;
  z-index: 999;
  width: 84.333%;
  height: 100%;
  margin-top: 0px;
  position: absolute;
  opacity: 1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0);
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  height: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(42, 196, 243);
  border-radius: 10px;
  height: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #0fa0ce;
  height: 10px;
}
#video .video {
  padding: 50px 0px 20px 0px;
  float: left;
  margin-left: -40px;
}
#video h2 {
  font-size: 18px;
  font-weight: 600;
  padding: 5px;
  position: relative;
  padding: 20px 0px 10px 0px;
}
#img .column {
  margin-left: 10px 50px;
  text-align: center;
  width: 23.33vw;
  margin-left: 16px;
  padding: 10px 1px 10px 0px;
}
.active_sidebar {
  color: #07CDDB !important;
  padding-left: 18px;
}
.active_icon {
  width: 20px;
  height: 2px;
  background: #0fa0ce !important;
  margin-top: 12px;
  position: absolute;
  margin-left: -30px;
}
.side-nemu ul li a {
  margin-left: -25px;
}
.submenuicon:hover {
  fill: #0fa0ce;
}
#img .column img {
  background: no-repeat;
  filter: grayscale(25%);
  transform: 1s;
  border-radius: 3px;
}
#img .column img:hover {
  filter: grayscale(0);
  transform: scale(1.03);
}
#img h2 {
  font-size: 18px;
  font-weight: 600;
  padding: 5px;
  position: relative;
}
/* Clearfix (clear floats) */
#img .row::after {
  content: "";
  clear: both;
  display: table;
}
#phoneshow {
  display: none;
}
#icon-search {
  margin-left: 0px;
  position: absolute;
}
#icon {
  margin-left: 10px;
  position: relative;
}
.icon-drop-phone {
  float: right;
  margin-right: 90px;
  margin-top: 4px;
}
.hideThis {
  display: none;
}
.dot {
  margin-left: -2px;
}
h1 {
  margin: 44px;
  margin-left: 0px;
}
ul li a:focus,
sub.id:active {
  background: #00b0ff;
}
p {
  padding: 5px;
}
main {
  color: #000000;
  text-align: center;
 
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-size: 30px;
  padding: 10px;
  font-weight: 600;
  margin-top: 20px;
}
ul {
  list-style-type: none;
  padding-left: 6px;
  text-align: left;
 
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 600;
  text-align: left;
  font-size: 14px;
}
a {
  color: darkgray;
}
a:hover {
  color: white;
}
.columns_content p {
  font-size: 17px;
}
.columns_content h2 {
  font-size: 36px;
  font-weight: 400;
  margin: 0;
  padding: 5px 0px;
}
.row {
  display: flex;
  flex-wrap: wrap;
}
#stickybody .sideber-top {
  margin-top: -50px;
}
#placeholder {
  opacity: 0;
}
#sidebar-fluid {
  margin-right: 15px;
  opacity: 1;
  height: auto;
  width: 310px;
  max-height: calc(100vh - 9rem);
  display: inline-table;
}
#sidebar-fluid h2 {
  font-size: 16px;
  margin-top: -20px;
  text-align: left;
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  text-align: center;
  font-weight: 600;
}
.phone_drop {
  display: none;
}
ul a {
  list-style-type: none;
  padding-left: 1px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 500;
  font-size: 20px;
}
.side-nemu {
  margin: 0;
  padding: 0;
  margin-top: -15px;
}

li a {
  font-size: 18px;
}
.blue_sub {
  color: #00b0ff;
}
ul li a:hover {
  color: #00b0ff;
}
#icon-search {
  color: #00b0ff;
}
#sidebar-fixed {
  margin-right: 15px;
  opacity: 1;
  height: auto;
  width: 300px;
  height: auto;
  width: 310px;
  position: fixed;
  display: none;
  margin-top: -241px;
}
#sidebar-fluid h1 {
  font-size: 20px;
  margin-top: -3px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  text-align: center;
  font-weight: 600;
  border-bottom: 1px solid rgb(138, 136, 136);
  text-align: center;
}
.column,
.columns {
  margin-left: 2%;
}
.aside {
  position: relative;
  position: -webkit-relative;
}
.columns_content {
  max-width: 80%;
}
.aside_body_content {
  margin-left: 10%;
  margin-top: -40px;
}
.aside_header_content {
  width: 78%;
  margin-left: 10%;
}
.aside_header_content h1 {
  margin: 0;
  margin-top: 60px;
  font-size: 36px;
  font-weight: 600;
}
.three.columns {
  border-right: 1px solid #706f6f;
}
.toggle-hiden {
  text-align: left;
  margin-left: 25px;
}
.icon_sidebar {
  width: 15px;
  margin-top: -4px;
}
.main h1 {
  color: #000000;
  text-align: center;


  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-size: 30px;
  padding: 5px;
  font-weight: 600;
}
.solid {
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: #00b0ff;
}
.submenuicon {
  float: right;
  margin-right: -50px;
  position: relative;
}
#sidebar-fluid ul li {
  width: 200px;
  cursor: pointer;
}

@media (max-width: 1200px) {
  #icon-search {
    margin-left: -5px;
    position: absolute;
  }
  #icon {
    margin-left: 0px;
    position: relative;
  }
  #sidebar-fixed {
    width: 280px;
  }
  #sidebar-fluid {
    width: 280px;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -90px;
    margin-left: -15px;
  }
  #sidebar-fluid ul li {
    width: 150px;
    cursor: pointer;
  }
  .submenuicon {
    float: right;
    margin-right: -70px;
    position: relative;
  }
  .shadow-body {
    width: 81%;
    height: 100%;
    margin-top: 0px;
    position: absolute;
    opacity: 1;
  }
  .aside_header_content h1 {
    margin: 0;
    margin-top: 60px;
    font-size: 32px;
    font-weight: 600;
  }
  li a {
    font-size: 16px;
    margin-left: 15px;
    width: 110%;
  }
  .icon_sidebar {
    width: 15px;
    margin-top: 4px;
    position: absolute;
  }
}
@media (max-width: 1100px) {
  .aside_header_content {
    width: 83%;
    margin-left: 5%;
  }
  .three.columns {
    margin-left: -50px;
  }
  .side-nemu {
    margin: 0;
    padding: 0;
    margin-top: -15px;
    margin-left: -40px;
  }
}
@media (max-width: 1024px) {
  #icon-search {
    margin-left: 30px;
    position: absolute;
  }
  #icon {
    margin-left: 30px;
    position: absolute;
  }
  #sidebar-fixed {
    width: 270px;
  }
  #sidebar-fluid {
    width: 270px;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -90px;
    margin-left: -15px;
  }
  #sidebar-fluid ul li {
    width: 150px;
    cursor: pointer;
  }
  .submenuicon {
    float: right;
    margin-right: -30px;
    position: relative;
  }
  #sidebar-fluid h1 {
    font-size: 20px;
  }
  .shadow-body {
    width: 82%;
    height: 100%;
    margin-top: 0px;
    position: absolute;
    opacity: 1;
  }
  .aside_header_content {
    width: 83%;
    margin-left: 5%;
  }
  .side-nemu {
    margin-left: -40px;
  }
  li a {
    font-size: 16px;
    margin-left: 15px;
    width: 110%;
  }
  .icon_sidebar {
    width: 15px;
    margin-top: 4px;
    position: absolute;
  }
}
@media (max-width: 990px) {
  #icon-search {
    margin-left: 10px;
    position: absolute;
  }
  .shadow-body {
    background: #fff;
    z-index: 999;
    width: 83%;
    height: 100%;
    position: absolute;
    opacity: 1;
    margin-left: -30px;
  }
  #icon {
    margin-left: 10px;
    position: absolute;
  }
  #sidebar-fixed {
    width: 170px;
  }
  #sidebar-fluid {
    width: 250px;
  }

  main {
    background-color: #fff;
    margin-bottom: 11px;
    padding-left: 11px;
    padding-top: 0px;
    box-shadow: 0px 3px 6px #00000029;
    opacity: 1;
    margin-top: -25px;
    z-index: 0;
    margin-left: -30px;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -80px;
    margin-left: -0px;
  }
  #sidebar-fluid ul li {
    width: 150px;
    cursor: pointer;
  }
  li a {
    font-size: 16px;
    margin-left: 15px;
    width: 110%;
  }
}
@media (max-width: 970px) {
  #sidebar-fixed {
    width: 230px;
  }
  #sidebar-fluid {
    width: 235px;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -80px;
    margin-left: 0px;
  }
  #sidebar-fluid ul li {
    width: 120px;
  }
  #sidebar-fluid h1 {
    font-size: 16px;
    margin-top: -10px;
    text-align: left;

    letter-spacing: 0px;
    opacity: 1;
    text-align: center;
    font-weight: 600;
    border-bottom: 1px solid rgb(138, 136, 136);
    padding: 10px;
    margin-left: 0px;
  }

  li a {
    font-size: 14px;
  }
  .main h1 {
    font-size: 26px;
    padding: 5px;
    text-align: center;
  }
  #sidebar-fluid ul li {
    width: 150px;
    cursor: pointer;
  }
  #icon-search {
    margin-left: -5px;
    position: absolute;
  }
  #icon {
    margin-left: 0px;
    position: relative;
  }
}
@media (max-width: 910px) {
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -75px;
    margin-left: -35px;
  }
  .shadow-body {
    background: #fff;
    z-index: 999;
    width: 81.433%;
    height: 100%;
    position: absolute;
    opacity: 1;
    margin-left: 10px;
    margin-top: -10px;
  }
  #sidebar-fixed {
    width: 320px;
  }
  #sidebar-fluid {
    width: 230px;
  }

  #sidebar-fluid h1 {
    font-size: 14px;
    margin-top: -15px;
    text-align: left;

    letter-spacing: 0px;
    opacity: 1;
    text-align: center;
    font-weight: 600;

    padding: 10px;
    margin-left: 0px;
  }

  li a {
    font-size: 12px;
  }
  .main h1 {
    margin-top: 20px;
    font-size: 26px;
    padding: 5px;
    text-align: center;
  }
  #sidebar-fluid ul li {
    width: 120px;
  }
  #sidebar-fluid {
    margin-right: 15px;
    opacity: 1;
    height: auto;
    width: 220px;
  }
  .main {
    margin-left: 10px;
  }
  #icon-search {
    margin-left: -5px;
    position: absolute;
  }
  #icon {
    margin-left: 0px;
    position: relative;
  }
  .submenuicon {
    float: right;
    margin-right: -60px;
    position: relative;
  }
  .side-nemu {
    margin-left: -30px;
  }
}
@media (max-width: 810px) {
  #icon {
    margin-left: 60px;
    position: absolute;
  }
  .shadow-body {
    margin-left: 5px;
    margin-top: -10px;
    width: 83%;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -70px;
    margin-left: -35px;
  }
  #sidebar-fixed {
    width: 210px;
  }
  #sidebar-fluid {
    width: 210px;
  }
  .side-nemu {
    margin-left: -25px;
  }
  #sidebar-fluid h1 {
    font-size: 14px;
    margin-top: -20px;
    text-align: left;

    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    font-weight: 600;
    border-bottom: 1px solid rgb(138, 136, 136);
    padding: 10px;
    margin-left: 0px;
  }

  li a {
    font-size: 12px;
  }
  .main h1 {
    font-size: 26px;
    padding: 5px;
    text-align: center;
  }
  #sidebar-fluid ul li {
    width: 100px;
  }
  #sidebar-fluid {
    margin-right: 15px;
    opacity: 1;
    height: auto;
    width: 190px;
  }
  .main {
    margin-left: 10px;
  }
  #icon-search {
    margin-left: -5px;
    position: absolute;
  }
  #icon {
    margin-left: 0px;
    position: relative;
  }
  .submenuicon {
    float: right;
    margin-right: -50px;
    position: relative;
  }
}
@media (max-width: 683px) {
  #desktopshow {
    display: none;
  }
  .side-nemu {
    margin-left: auto;
  }
  .three.columns {
    margin-left: auto;
  }
  .aside_header_content {
    width: 80%;
    margin-left: 10%;
  }
  .aside_header_content h1 {
    font-size: 22px;
  }
  .columns_content {
    margin-top: 50px;
  }
  .shadow-body {
    margin-left: -35px;
    margin-top: -10px;
    width: 150%;
  }
  .submenuicon {
    float: right;
    margin-right: 0px;
    position: relative;
  }
  #phoneshow {
    display: block;
    padding: 0px 0px 40px 0px;
    position: absolute;
    z-index: 1001;
  }
  #icon-search {
    margin-left: 60px;
    position: absolute;
  }
  #icon {
    margin-left: 60px;
    position: absolute;
  }
  #sidebar-fluid {
    /* reset sidebar to remove static width*/
    width: 250px;
    max-width: 60%;
    z-index: 1001;
    position: absolute;
    padding: 6px 0px 8px 0px;
    border-radius: 8px;
    margin-left: 15%;
  }

  #sidebar-fluid h1 {
    font-size: 16px;
    text-align: left;

    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    font-weight: 600;
    border-bottom: none;
    margin-left: 0px;
    box-shadow: 1px 0px 4px #fff0;
    border-radius: 6px;
    /* font-size: .5rem; */
    /* height: 30px; */

    display: inline;
  }
  .side-nemu {
    margin: 0;
    padding: 0;
    margin-top: 15px;
    margin-left: 5px;
  }

  .main h1 {
    margin-left: 0px;
    font-size: 18px;
    padding: 5px;
    text-align: center;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -45px;
    margin-left: -55px;
  }
  .icon-drop-phone {
    margin-top: -2px;
    position: absolute;
    margin-left: 110px;
  }
  .icon-drop1{
    margin-left: 140px;
    margin-top: 0px;
    float: right;
    position: absolute;
    color: #07cddb;
    font-size: 16px;
}
  .aside_ul {
    list-style-type: none;
    margin-left: 15px;
    max-width: 100%;
  }
  .main {
    display: block;
  }
  .phone-position {
    margin-left: -30px;
  }
  #sidebar-fluid ul li {
    width: 200px;
  }
}
@media (max-width: 480px) {
  #desktopshow {
    display: none;
  }
  .submenuicon {
    float: right;
    margin-right: 0px;
    position: relative;
  }
  #phoneshow {
    display: block;
    padding: 0px 0px 40px 0px;
    position: absolute;
    z-index: 1001;
  }
  #icon-search {
    margin-left: 60px;
    position: absolute;
  }
  #icon {
    margin-left: 60px;
    position: absolute;
  }
  #sidebar-fluid {
    /* reset sidebar to remove static width*/
    width: 190px;
    max-width: 60%;
    margin-left: 50%;
    margin-top: 0px;
    box-shadow: 0px 0px 3px #b9b9b9d6;
    z-index: 1001;
    position: absolute;
    padding: 8px;
    border-radius: 8px;
  }
  .aside_header_content {
    width: 72%;
    margin-left: 15%;
  }
  #sidebar-fluid h1 {
    font-size: 16px;
    text-align: left;

    letter-spacing: 0px;

    opacity: 1;
    text-align: left;
    font-weight: 600;
    border-bottom: none;
    margin-left: 0px;
    box-shadow: 1px 0px 4px #fff0;
    border-radius: 6px;
    /* font-size: .5rem; */
    /* height: 30px; */

    display: inline;
  }

  .icon-drop-phone {
    margin-top: -2px;
    position: absolute;
    margin-left: 96px;
  }
   .icon-drop1{
    margin-left: 70px;
    margin-top: 0px;
    float: right;
    position: absolute;
    color: #07cddb;
    font-size: 16px;
}
  .main h1 {
    margin-left: 0px;
    font-size: 18px;
    padding: 5px;
    text-align: center;
  }
  .shadow-body {
    width: 150vw;
  }
  .phone-position {
    margin-left: -35px;
  }
  .columns_content {
    max-width: 80%;
    margin-left: 5%;
  }
}
@media (max-width: 380px) {
  #desktopshow {
    display: none;
  }
  .submenuicon {
    float: right;
    margin-right: 0px;
    position: relative;
  }
  .columns_content {
    max-width: 80%;
    margin-left: 6%;
  }
  #phoneshow {
    display: block;
    padding: 0px 0px 40px 0px;
    position: absolute;
    z-index: 1001;
  }
  #icon-search {
    margin-left: 60px;
    position: absolute;
  }
  #icon {
    margin-left: 60px;
    position: absolute;
  }
  .icon-drop-phone {
    margin-top: -2px;
    position: absolute;
    margin-left: 96px;
  }
  #sidebar-fluid {
    /* reset sidebar to remove static width*/
    width: 190px;
    max-width: 60%;
    margin-left: 50%;
    margin-top: 0px;
    box-shadow: 0px 0px 3px #b9b9b9d6;
    z-index: 1001;
    position: absolute;
    padding: 8px;
    border-radius: 8px;
  }

  #sidebar-fluid h1 {
    font-size: 16px;
    text-align: left;

    letter-spacing: 0px;

    opacity: 1;
    text-align: left;
    font-weight: 600;
    border-bottom: none;
    margin-left: 0px;
    box-shadow: 1px 0px 4px #fff0;
    border-radius: 6px;
    /* font-size: .5rem; */
    /* height: 30px; */

    display: inline;
  }

  .main h1 {
    margin-left: 0px;
    font-size: 18px;
    padding: 5px;
    text-align: center;
  }
  ul {
    list-style-type: none;
    padding-left: 6px;
    text-align: left;

    letter-spacing: 0px;
    opacity: 1;
    font-weight: 600;
    text-align: left;
    margin-left: 5px;
    font-size: 14px;
  }

  .shadow-body {
    width: 150%;
    padding-left: 55px;
  }
  .phone-position {
    margin-left: -35px;
  }
}
/**
 * Correct `block` display not defined for any HTML5 element in IE 8/9.
 * Correct `block` display not defined for `details` or `summary` in IE 10/11
 * and Firefox.
 * Correct `block` display not defined for `main` in IE 11.
 */

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

/**
 * 1. Correct `inline-block` display not defined in IE 8/9.
 * 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.
 */

audio,
canvas,
progress,
video {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

/**
 * Prevent modern browsers from displaying `audio` without controls.
 * Remove excess height in iOS 5 devices.
 */

audio:not([controls]) {
  display: none;
  height: 0;
}

/**
 * Address `[hidden]` styling not present in IE 8/9/10.
 * Hide the `template` element in IE 8/9/11, Safari, and Firefox < 22.
 */

[hidden],
template {
  display: none;
}

/* Links
   ========================================================================== */

/**
 * Remove the gray background color from active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * Improve readability when focused and also mouse hovered in all browsers.
 */

a:active,
a:hover {
  outline: 0;
}

/* Text-level semantics
   ========================================================================== */

/**
 * Address styling not present in IE 8/9/10/11, Safari, and Chrome.
 */

abbr[title] {
  border-bottom: 1px dotted;
}

/**
 * Address style set to `bolder` in Firefox 4+, Safari, and Chrome.
 */

b,
strong {
  font-weight: bold;
}

/**
 * Address styling not present in Safari and Chrome.
 */

dfn {
  font-style: italic;
}

/**
 * Address variable `h1` font-size and margin within `section` and `article`
 * contexts in Firefox 4+, Safari, and Chrome.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/**
 * Address styling not present in IE 8/9.
 */

mark {
  background: #ff0;
  color: #000;
}

/**
 * Address inconsistent and variable font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` affecting `line-height` in all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove border when inside `a` element in IE 8/9/10.
 */

img {
  border: 0;
}

/**
 * Correct overflow not hidden in IE 9/10/11.
 */

svg:not(:root) {
  overflow: hidden;
}

/* Grouping content
   ========================================================================== */

/**
 * Address margin not present in IE 8/9 and Safari.
 */

figure {
  margin: 1em 40px;
}

/**
 * Address differences between Firefox and other browsers.
 */

hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}

/**
 * Contain overflow in all browsers.
 */

pre {
  overflow: auto;
}

/**
 * Address odd `em`-unit font size rendering in all browsers.
 */

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

/* Forms
   ========================================================================== */

/**
 * Known limitation: by default, Chrome and Safari on OS X allow very limited
 * styling of `select`, unless a `border` property is set.
 */

/**
 * 1. Correct color not being inherited.
 *    Known issue: affects color of disabled elements.
 * 2. Correct font properties not being inherited.
 * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.
 */

button,
input,
optgroup,
select,
textarea {
  color: inherit; /* 1 */
  font: inherit; /* 2 */
  margin: 0; /* 3 */
}

/**
 * Address `overflow` set to `hidden` in IE 8/9/10/11.
 */

button {
  overflow: visible;
}

/**
 * Address inconsistent `text-transform` inheritance for `button` and `select`.
 * All other form control elements do not inherit `text-transform` values.
 * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.
 * Correct `select` style inheritance in Firefox.
 */

button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`
 *    and `video` controls.
 * 2. Correct inability to style clickable `input` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    `input` and others.
 */

button,
html input[type="button"], /* 1 */
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
}

/**
 * Re-set default cursor for disabled elements.
 */

button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * Remove inner padding and border in Firefox 4+.
 */

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * Address Firefox 4+ setting `line-height` on `input` using `!important` in
 * the UA stylesheet.
 */

input {
  line-height: normal;
}

/**
 * It's recommended that you don't attempt to style these elements.
 * Firefox's implementation doesn't respect box-sizing, padding, or width.
 *
 * 1. Address box sizing set to `content-box` in IE 8/9/10.
 * 2. Remove excess padding in IE 8/9/10.
 */

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Fix the cursor style for Chrome's increment/decrement buttons. For certain
 * `font-size` values of the `input`, it causes the cursor style of the
 * decrement button to change from `default` to `text`.
 */

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Address `appearance` set to `searchfield` in Safari and Chrome.
 * 2. Address `box-sizing` set to `border-box` in Safari and Chrome
 *    (include `-moz` to future-proof).
 */

input[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box; /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari and Chrome on OS X.
 * Safari (but not Chrome) clips the cancel button when the search input has
 * padding (and `textfield` appearance).
 */

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Define consistent border, margin, and padding.
 */

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct `color` not being inherited in IE 8/9/10/11.
 * 2. Remove padding so people aren't caught out if they zero out fieldsets.
 */

legend {
  border: 0; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Remove default vertical scrollbar in IE 8/9/10/11.
 */

textarea {
  overflow: auto;
}

/**
 * Don't inherit the `font-weight` (applied by a rule above).
 * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
 */

optgroup {
  font-weight: bold;
}

/* Tables
   ========================================================================== */

/**
 * Remove most spacing between table cells.
 */

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}
/* Table of contents
––––––––––––––––––––––––––––––––––––––––––––––––––
- Grid
- Base Styles
- Typography
- Links
- Buttons
- Forms
- Lists
- Code
- Tables
- Spacing
- Utilities
- Clearing
- Media Queries
*/

/* Grid
–––––––––––––––––––––––––––––––––––––––––––––––––– */
.container {
  position: relative;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.column,
.columns {
  width: 100%;
  float: left;
  box-sizing: border-box;
}

/* For devices larger than 400px */
@media (min-width: 400px) {
  .container {
    width: 85%;
  }
}

/* For devices larger than 550px */
@media (min-width: 684px) {
  .container {
    width: 84%;
  }
  .column,
  .columns {
    margin-left: 4%;
  }
  .column:first-child,
  .columns:first-child {
    margin-left: 0;
  }

  .one.column,
  .one.columns {
    width: 4.66666666667%;
  }
  .two.columns {
    width: 13.3333333333%;
  }
  .three.columns {
    width: 20%;
  }
  .four.columns {
    width: 30.6666666667%;
  }
  .five.columns {
    width: 39.3333333333%;
  }
  .six.columns {
    width: 48%;
  }
  .seven.columns {
    width: 56.6666666667%;
  }
  .eight.columns {
    width: 65.3333333333%;
  }
  .nine.columns {
    width: 76%;
  }
  .ten.columns {
    width: 82.6666666667%;
  }
  .eleven.columns {
    width: 91.3333333333%;
  }
  .twelve.columns {
    width: 100%;
    margin-left: 0;
  }

  .one-third.column {
    width: 30.6666666667%;
  }
  .two-thirds.column {
    width: 65.3333333333%;
  }

  .one-half.column {
    width: 48%;
  }

  /* Offsets */
  .offset-by-one.column,
  .offset-by-one.columns {
    margin-left: 8.66666666667%;
  }
  .offset-by-two.column,
  .offset-by-two.columns {
    margin-left: 17.3333333333%;
  }
  .offset-by-three.column,
  .offset-by-three.columns {
    margin-left: 26%;
  }
  .offset-by-four.column,
  .offset-by-four.columns {
    margin-left: 34.6666666667%;
  }
  .offset-by-five.column,
  .offset-by-five.columns {
    margin-left: 43.3333333333%;
  }
  .offset-by-six.column,
  .offset-by-six.columns {
    margin-left: 52%;
  }
  .offset-by-seven.column,
  .offset-by-seven.columns {
    margin-left: 60.6666666667%;
  }
  .offset-by-eight.column,
  .offset-by-eight.columns {
    margin-left: 69.3333333333%;
  }
  .offset-by-nine.column,
  .offset-by-nine.columns {
    margin-left: 78%;
  }
  .offset-by-ten.column,
  .offset-by-ten.columns {
    margin-left: 86.6666666667%;
  }
  .offset-by-eleven.column,
  .offset-by-eleven.columns {
    margin-left: 95.3333333333%;
  }

  .offset-by-one-third.column,
  .offset-by-one-third.columns {
    margin-left: 34.6666666667%;
  }
  .offset-by-two-thirds.column,
  .offset-by-two-thirds.columns {
    margin-left: 69.3333333333%;
  }

  .offset-by-one-half.column,
  .offset-by-one-half.columns {
    margin-left: 52%;
  }
}

/* Base Styles
–––––––––––––––––––––––––––––––––––––––––––––––––– */
/* NOTE
html is set to 62.5% so that all the REM measurements throughout Skeleton
are based on 10px sizing. So basically 1.5rem = 15px :) */
html {
  font-size: 62.5%;
}
body {
  font-size: 1.5em; /* currently ems cause chrome bug misinterpreting rems on body element */
  line-height: 1.6;
  font-weight: 400;
  font-family: "Raleway", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: #222;
}

/* Typography
–––––––––––––––––––––––––––––––––––––––––––––––––– */
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 2rem;
  font-weight: 300;
}
h1 {
  font-size: 4rem;
  line-height: 1.2;
  letter-spacing: 0rem;
}
h2 {
  font-size: 3.6rem;
  line-height: 1.25;
  letter-spacing: -0.1rem;
}
h3 {
  font-size: 3rem;
  line-height: 1.3;
  letter-spacing: -0.1rem;
}
h4 {
  font-size: 2.4rem;
  line-height: 1.35;
  letter-spacing: -0.08rem;
}
h5 {
  font-size: 1.8rem;
  line-height: 1.5;
  letter-spacing: -0.05rem;
}
h6 {
  font-size: 1.5rem;
  line-height: 1.6;
  letter-spacing: 0;
}

/* Larger than phablet */
@media (min-width: 683px) {
  h1 {
    font-size: 5rem;
  }
  h2 {
    font-size: 4.2rem;
  }
  h3 {
    font-size: 3.6rem;
  }
  h4 {
    font-size: 3rem;
  }
  h5 {
    font-size: 2.4rem;
  }
  h6 {
    font-size: 1.5rem;
  }
}

p {
  margin-top: 0;
}

/* Links
–––––––––––––––––––––––––––––––––––––––––––––––––– */
a {
  color: #1eaedb;
}
a:hover {
  color: #0fa0ce;
}

/* Buttons
–––––––––––––––––––––––––––––––––––––––––––––––––– */
.button,
button,
input[type="submit"],
input[type="reset"],
input[type="button"] {
  display: inline-block;
  height: 38px;
  padding: 0 30px;
  color: #555;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid #bbb;
  cursor: pointer;
  box-sizing: border-box;
}
.button:hover,
button:hover,
input[type="submit"]:hover,
input[type="reset"]:hover,
input[type="button"]:hover,
.button:focus,
button:focus,
input[type="submit"]:focus,
input[type="reset"]:focus,
input[type="button"]:focus {
  color: #333;
  border-color: #888;
  outline: 0;
}
.button.button-primary,
button.button-primary,
input[type="submit"].button-primary,
input[type="reset"].button-primary,
input[type="button"].button-primary {
  color: #fff;
  background-color: #33c3f0;
  border-color: #33c3f0;
}
.button.button-primary:hover,
button.button-primary:hover,
input[type="submit"].button-primary:hover,
input[type="reset"].button-primary:hover,
input[type="button"].button-primary:hover,
.button.button-primary:focus,
button.button-primary:focus,
input[type="submit"].button-primary:focus,
input[type="reset"].button-primary:focus,
input[type="button"].button-primary:focus {
  color: #fff;
  background-color: #1eaedb;
  border-color: #1eaedb;
}

/* Forms
–––––––––––––––––––––––––––––––––––––––––––––––––– */
input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea,
select {
  height: 38px;
  padding: 6px 10px; /* The 6px vertically centers text on FF, ignored by Webkit */
  background-color: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  box-shadow: none;
  box-sizing: border-box;
}
/* Removes awkward default styles on some inputs for iOS */
input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
textarea {
  min-height: 65px;
  padding-top: 6px;
  padding-bottom: 6px;
}
input[type="email"]:focus,
input[type="number"]:focus,
input[type="search"]:focus,
input[type="text"]:focus,
input[type="tel"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
textarea:focus,
select:focus {
  border: 1px solid #33c3f0;
  outline: 0;
}
label,
legend {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
fieldset {
  padding: 0;
  border-width: 0;
}
input[type="checkbox"],
input[type="radio"] {
  display: inline;
}
label > .label-body {
  display: inline-block;
  margin-left: 0.5rem;
  font-weight: normal;
}

/* Lists
–––––––––––––––––––––––––––––––––––––––––––––––––– */
/*ul {
  list-style: circle inside; }*/
ol {
  list-style: decimal inside;
}
ol,
ul {
  padding-left: 0;
  margin-top: 0;
}
ul ul,
ul ol,
ol ol,
ol ul {
  margin: 1rem 0 1.5rem 2rem;
  font-size: 90%;
}
li {
  margin-bottom: 1rem;
}

/* Code
–––––––––––––––––––––––––––––––––––––––––––––––––– */
code {
  padding: 0.2rem 0.5rem;
  margin: 0 0.2rem;
  font-size: 90%;
  white-space: nowrap;
  background: #f1f1f1;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
}
pre > code {
  display: block;
  padding: 1rem 1.5rem;
  white-space: pre;
}

/* Tables
–––––––––––––––––––––––––––––––––––––––––––––––––– */
th,
td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e1e1e1;
}
th:first-child,
td:first-child {
  padding-left: 0;
}
th:last-child,
td:last-child {
  padding-right: 0;
}

/* Spacing
–––––––––––––––––––––––––––––––––––––––––––––––––– */
button,
.button {
  margin-bottom: 1rem;
}
input,
textarea,
select,
fieldset {
  margin-bottom: 1.5rem;
}
pre,
blockquote,
dl,
figure,
table,
p,
ul,
ol,
form {
  margin-bottom: 2.5rem;
}

/* Utilities
–––––––––––––––––––––––––––––––––––––––––––––––––– */
.u-full-width {
  width: 100%;
  box-sizing: border-box;
}
.u-max-full-width {
  max-width: 100%;
  box-sizing: border-box;
}
.u-pull-right {
  float: right;
}
.u-pull-left {
  float: left;
}

/* Misc
–––––––––––––––––––––––––––––––––––––––––––––––––– */
hr {
  margin-top: 0.3rem;
  margin-bottom: 3.5rem;
  border-width: 0;
  border-top: 2px solid #706f6f;
}

/* Clearing
–––––––––––––––––––––––––––––––––––––––––––––––––– */

/* Self Clearing Goodness */
.container:after,
.row:after,
.u-cf {
  content: "";
  display: table;
  clear: both;
}

/* Media Queries
–––––––––––––––––––––––––––––––––––––––––––––––––– */

/* Larger than mobile */
@media (min-width: 400px) {
}

/* Larger than phablet (also point when grid becomes active) */
@media (min-width: 550px) {
}

/* Larger than tablet */
@media (min-width: 750px) {
}

/* Larger than desktop */
@media (min-width: 1000px) {
}

/* Larger than Desktop HD */
@media (min-width: 1200px) {
}
</style>